export class ArchiveProduct {
	constructor($page) {
		this.$page = $page;
		this.$list = this.$page.find('.js-products-wrapper');
		this.$tags = this.$page.find('.js-tags');
		this.tags = [];
		this.ajaxCallCount = 0;

		this.init();
	}

	init() {
		var self = this;

		self.$tags.on('click', 'input[type=checkbox]', function() {
			self.filter($(this).data('tag'), $(this).is(':checked'));
		});
	}

	filter(tagId, isChecked) {
		var self = this;

		self.$page.addClass('loading');
		self.ajaxCallCount++;

		if (isChecked && self.tags.indexOf(tagId) == -1) {
			this.tags.push(tagId);
		}
		else {
			const i = self.tags.indexOf(tagId);
			if (i !== -1) {
				self.tags.splice(i, 1);
			}
		}
		const category = self.$list.data('category');

		$.ajax({
			url: window.sage.ajax['archive.product.filter'],
			method: 'POST',
			data: {
				filters: {category: category, tags: self.tags},
			},
			success: function(data) {
				console.log(self.$list);
				self.$list.html(data.data.html);
				self.ajaxCallCount--;
				if (self.ajaxCallCount < 1) {
					self.$page.removeClass('loading');
				}
			},
		}).fail(function(textStatus, errorThrown) {
			self.ajaxCallCount--;
			if (self.ajaxCallCount < 1) {
				self.$page.removeClass('loading');
			}
			console.log(textStatus);
			console.log(errorThrown);
		});
	}
}



// WEBPACK FOOTER //
// ./scripts/src/archive-product.js